import moment from 'moment'

export interface CustomerModel {
  id: number
  createdAt: string | Date
  name: string
  order: number
}

export type CustomerListResponse = CustomerModel[]

export default class Customer {
  private constructor (
    readonly id: number,
    readonly createdAt: Date,
    readonly name: string,
    readonly order: number
  ) {}

  get iri (): string {
    return `/api/customer/${this.id}`
  }

  public static createFromModel (data: Partial<CustomerModel>): Customer {
    return new Customer(
      data.id!,
      data.createdAt ? moment(data.createdAt).toDate() : new Date(),
      data.name!,
      data.order || 0
    )
  }

  public static createFromResponse (data: CustomerListResponse): Customer[] {
    return data.map((item: CustomerModel) => Customer.createFromModel(item))
  }
}
